

import controller from './modal-confirmation-save-items.controller';
import template from './templates/template-base.view.html';


let ModalConfirmationSaveItemsComponent = {
    template,
    controller,
    bindings: {
        // dataProducs:'<',
        // dataCart:'@' 
        productAdded:'<',
        mdName: '@',
        //producsData:'<',
        //cartData:'<'
    }
};

export default ModalConfirmationSaveItemsComponent;




/** WEBPACK FOOTER **
 ** C:/Users/dares/Documents/SIESA_repositorios/himalaya/www/components/catalog/modal-confirmation-save-items/modal-confirmation-save-items.component.js
 **/